import React from 'react';
import { ModalContainer } from './ModalContainer';
import ModalLayout from './ModalLayout';
import { ModalProps } from './ModalProps';

interface IModalProps extends ModalProps {
  hideCloseButton?: boolean;
  maxWidth?: number;
  className?: string;
  closeOnOutSideClick?: boolean;
}

const Modal = ({ isActive, onClose, hideCloseButton, maxWidth, children, className, closeOnOutSideClick = true, dataCy, ...rest }: IModalProps) => (
  <ModalContainer isActive={isActive} onClose={onClose} closeOnOutSideClick={closeOnOutSideClick} dataCy={dataCy}>
    <ModalLayout maxWidth={maxWidth} onClose={onClose} hideCloseButton={hideCloseButton} isActive={isActive} className={className} {...rest}>
      {children}
    </ModalLayout>
  </ModalContainer>
);

export default Modal;
